import { GETSESSION_SUCCESS, GETSESSION_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const getSessionReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETSESSION_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETSESSION_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: [],
            };
        default:
            break;
    }

    return state;
};

export default getSessionReducer;



